import React from "react";
import { useTranslation } from "react-i18next";
import InputAutoresize from "../../../../common/components/form/InputAutoresize.jsx";
import InputSelect from "../../../../common/components/form/InputSelect.jsx";
import { PayPalCurrencies, PayPalCurrenciesValues } from "../../../../common/constant/paypal.js";

const REExceptIntegersDots = /[^\d\.]+/g;
const REExceptIntegers = /(\.\d+$|[^\d]+)/g;
const REInteger11Fractional2 = /^(\d{1,11})\d*\.(\d{1,2})\d*$/;
export default function PricingSettings(props) {
    const { t } = useTranslation();

    const {
        set,
        variables,
        variables: { Pricing },
    } = props;

    let _Pricing = Pricing || { currency: "USD", price: "", basis: "" };

    const { decimal } = PayPalCurrencies[_Pricing.currency] || {};

    React.useEffect(() => {
        const _upd = {};

        let _newPrice = _Pricing.price
            .toString()
            .replace(decimal === false ? REExceptIntegers : REExceptIntegersDots, "");

        let _newBasis = _Pricing.basis
            .toString()
            .replace(decimal === false ? REExceptIntegers : REExceptIntegersDots, "");

        _newPrice !== _Pricing.price && (_upd.price = _newPrice);
        _newBasis !== _Pricing.basis && (_upd.basis = _newBasis);

        if (_upd.price !== undefined || _upd.basis !== undefined) {
            set({ ...variables, Pricing: { ..._Pricing, ..._upd } });
        }
    }, [variables]);

    function onCurrencyChange(value) {
        _Pricing.currency = value;
        set({ ...variables, Pricing: { ..._Pricing } });
    }

    function onPriceChange(event) {
        _Pricing.price = event.target.value.replace(decimal === false ? REExceptIntegers : REExceptIntegersDots, "");
        _Pricing.price = _Pricing.price.split(".").slice(0, 2).join(".");
        _Pricing.price = _Pricing.price.replace(REInteger11Fractional2, "$1.$2");

        if (event.type === "blur") {
            _Pricing.price = _Pricing.price.trim();

            if (
                !isNaN(_Pricing.price) &&
                !isNaN(_Pricing.basis) &&
                parseFloat(_Pricing.price) > parseFloat(_Pricing.basis)
            ) {
                _Pricing.basis = _Pricing.price;
            }
        }

        set({ ...variables, Pricing: { ..._Pricing } });
    }

    function onBasisChange(event) {
        _Pricing.basis = event.target.value.replace(decimal === false ? REExceptIntegers : REExceptIntegersDots, "");
        _Pricing.basis = _Pricing.basis.split(".").slice(0, 2).join(".");
        _Pricing.basis = _Pricing.basis.replace(REInteger11Fractional2, "$1.$2");

        if (event.type === "blur") {
            _Pricing.basis = _Pricing.basis.trim();

            if (
                !isNaN(_Pricing.price) &&
                !isNaN(_Pricing.basis) &&
                parseFloat(_Pricing.price) > parseFloat(_Pricing.basis)
            ) {
                _Pricing.price = _Pricing.basis;
            }
        }

        set({ ...variables, Pricing: { ..._Pricing } });
    }

    return (
        <div className="grid-gap-20 align-content-start text-left">
            <div className="text-left">
                <h3>{t("SetYourProductPrice")}:</h3>
            </div>

            <div className="grid-gap-10">
                <InputSelect
                    onSelect={onCurrencyChange}
                    options={PayPalCurrenciesValues.map(({ code, name }) => ({
                        text: `(${code.toUpperCase()}) ${name}`,
                        value: code,
                    }))}
                    selected={_Pricing.currency}
                    placeholder={t("Select Currency")}
                    fullWidth
                    filterField
                />

                <InputAutoresize
                    onChange={onPriceChange}
                    onBlur={onPriceChange}
                    value={_Pricing.price || ""}
                    placeholder={t("Product price")}
                    fullWidth
                />

                <InputAutoresize
                    onChange={onBasisChange}
                    onBlur={onBasisChange}
                    value={_Pricing.basis || ""}
                    placeholder={t("Price before discount (optional)")}
                    fullWidth
                />
            </div>
        </div>
    );
}
